(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoStoriesCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.video-stories-carousel__track');
      this.prevBtn = section.querySelector('.video-stories-carousel__nav--prev');
      this.nextBtn = section.querySelector('.video-stories-carousel__nav--next');
      this.slides = section.querySelectorAll('.video-stories-carousel__slide');
      this.videos = section.querySelectorAll('.video-stories-carousel__video-inner video');
      this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.modal = section.querySelector('.video-stories-modal');

      if (!this.track || this.slides.length === 0) return;

      this.bindEvents();
      this.updateNavState();
      this.prepareCarouselVideos();

      if (this.autoplayEnabled && !this.reducedMotion) {
        this.initAutoplay();
      }

      if (this.modal) {
        this.storiesModal = new VideoStoriesModal(section, this);
      }
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.track.addEventListener('scroll', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
      window.addEventListener('resize', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
    }

    prepareCarouselVideos() {
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.controls = false;
        video.removeAttribute('controls');
        video.playsInline = true;
        video.disablePictureInPicture = true;
        video.setAttribute('disablepictureinpicture', '');

        video.addEventListener('loadeddata', () => this.playCarouselVideo(video));
        video.addEventListener('canplay', () => this.playCarouselVideo(video));
      });
    }

    playCarouselVideo(video) {
      if (!video || !this.autoplayEnabled) return;
      if (!this.isVideoVisibleInTrack(video)) return;

      video.muted = true;
      video.defaultMuted = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setTimeout(() => this.playCarouselVideo(video), 300);
        });
      }
    }

    isVideoVisibleInTrack(video) {
      const trackRect = this.track.getBoundingClientRect();
      const videoRect = video.getBoundingClientRect();
      return videoRect.right > trackRect.left + 4 && videoRect.left < trackRect.right - 4;
    }

    playVisibleCarouselVideos() {
      if (!this.autoplayEnabled || this.reducedMotion) return;

      this.videos.forEach((video) => {
        if (this.isVideoVisibleInTrack(video)) {
          this.playCarouselVideo(video);
        } else {
          video.pause();
        }
      });
    }

    initAutoplay() {
      this.playVisibleCarouselVideos();

      requestAnimationFrame(() => this.playVisibleCarouselVideos());
      setTimeout(() => this.playVisibleCarouselVideos(), 100);
      setTimeout(() => this.playVisibleCarouselVideos(), 500);
      setTimeout(() => this.playVisibleCarouselVideos(), 1500);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                this.playCarouselVideo(video);
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: 0.25 }
        );

        this.videos.forEach((video) => observer.observe(video));
      }
    }

    getScrollAmount() {
      const slide = this.slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(this.section).getPropertyValue('--vsc-gap')) || 16;
      return slide.offsetWidth + gap;
    }

    scroll(direction) {
      const amount = this.getScrollAmount();
      this.track.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const tolerance = 2;

      this.prevBtn.disabled = this.track.scrollLeft <= tolerance;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - tolerance;
    }

  }

  class VideoStoriesModal {
    constructor(section, carousel) {
      this.section = section;
      this.carousel = carousel;
      this.modal = section.querySelector('.video-stories-modal');
      this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
      this.progressEl = section.querySelector('[data-story-progress]');
      this.currentIndex = 0;
      this.isMuted = true;
      this.progressRaf = null;

      if (!this.modal || this.stories.length === 0) return;

      this.buildProgress();
      this.bindEvents();
    }

    bindEvents() {
      this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const index = parseInt(trigger.dataset.storyOpen, 10);
          this.open(index);
        });
      });

      this.modal.querySelectorAll('[data-story-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.modal.querySelectorAll('[data-story-prev]').forEach((el) => {
        el.addEventListener('click', () => this.prev());
      });

      this.modal.querySelectorAll('[data-story-next]').forEach((el) => {
        el.addEventListener('click', () => this.next());
      });

      this.modal.querySelectorAll('[data-story-mute]').forEach((el) => {
        el.addEventListener('click', () => this.toggleMute());
      });

      this.modal.querySelectorAll('[data-add-to-cart]').forEach((el) => {
        el.addEventListener('click', () => this.addToCart(el));
      });

      document.addEventListener('keydown', (event) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.prev();
        if (event.key === 'ArrowRight') this.next();
      });
    }

    buildProgress() {
      if (!this.progressEl) return;
      this.progressEl.innerHTML = '';
      this.stories.forEach((_, index) => {
        const segment = document.createElement('div');
        segment.className = 'video-stories-modal__progress-segment';
        segment.dataset.segmentIndex = index;
        const fill = document.createElement('span');
        fill.className = 'video-stories-modal__progress-fill';
        segment.appendChild(fill);
        this.progressEl.appendChild(segment);
      });
      this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
    }

    open(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('video-stories-modal-open');
      this.carousel.videos.forEach((video) => video.pause());
      this.showStory(this.currentIndex);
    }

    close() {
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('video-stories-modal-open');
      this.pauseAllStories();
      cancelAnimationFrame(this.progressRaf);
      this.carousel.playVisibleCarouselVideos();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.showStory(this.currentIndex - 1);
      } else {
        this.close();
      }
    }

    next() {
      if (this.currentIndex < this.stories.length - 1) {
        this.showStory(this.currentIndex + 1);
      } else {
        this.close();
      }
    }

    showStory(index) {
      this.currentIndex = index;
      this.stories.forEach((story, i) => {
        story.classList.remove('is-active', 'is-adjacent');
        if (i === index) {
          story.classList.add('is-active');
        } else if (i === index - 1 || i === index + 1) {
          story.classList.add('is-adjacent');
        }
      });
      this.updateProgressUI();
      this.playActiveStory();
    }

    getActiveVideo() {
      const story = this.stories[this.currentIndex];
      return story?.querySelector('.video-stories-modal__video') || null;
    }

    playActiveStory() {
      this.pauseAllStories();
      const video = this.getActiveVideo();
      if (!video) {
        this.startFallbackProgress(5000);
        return;
      }

      video.currentTime = 0;
      video.muted = this.isMuted;
      video.play().catch(() => {});
      video.onended = () => this.next();
      this.trackProgress(video);
    }

    pauseAllStories() {
      this.stories.forEach((story) => {
        const video = story.querySelector('.video-stories-modal__video');
        if (video) {
          video.pause();
          video.onended = null;
        }
      });
      cancelAnimationFrame(this.progressRaf);
    }

    trackProgress(video) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const update = () => {
        if (!video.duration || Number.isNaN(video.duration)) {
          this.progressRaf = requestAnimationFrame(update);
          return;
        }
        fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
        if (!video.paused && !video.ended) {
          this.progressRaf = requestAnimationFrame(update);
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(update);
    }

    startFallbackProgress(duration) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        fill.style.width = `${progress * 100}%`;
        if (progress < 1) {
          this.progressRaf = requestAnimationFrame(tick);
        } else {
          this.next();
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(tick);
    }

    updateProgressUI() {
      this.segments.forEach((segment, i) => {
        const fill = segment.querySelector('.video-stories-modal__progress-fill');
        segment.classList.toggle('is-complete', i < this.currentIndex);
        if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
      });
    }

    toggleMute() {
      this.isMuted = !this.isMuted;
      const video = this.getActiveVideo();
      if (video) video.muted = this.isMuted;

      this.modal.querySelectorAll('[data-story-mute]').forEach((btn) => {
        const onIcon = btn.querySelector('.video-stories-modal__mute-icon--on');
        const offIcon = btn.querySelector('.video-stories-modal__mute-icon--off');
        if (onIcon) onIcon.hidden = !this.isMuted;
        if (offIcon) offIcon.hidden = this.isMuted;
        btn.setAttribute('aria-label', this.isMuted ? 'Ativar som' : 'Desativar som');
      });
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adicionando...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });

        if (!response.ok) throw new Error('Cart error');

        button.textContent = 'Adicionado!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      } catch (error) {
        button.textContent = 'Erro ao adicionar';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    }
  }

  function initVideoStoriesCarousels() {
    document.querySelectorAll('.video-stories-carousel[data-section-id]').forEach((section) => {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    });
  }

  initVideoStoriesCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.video-stories-carousel[data-section-id]');
    if (section) {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
